import ErrorDefinitionTranslation from "./ErrorDefinitionTranslation";

export default class ErrorDefinition {
    public id!: number;
    public errorId!: number;
    public componentType!: string;
    public errorLevel!: string;
    public translations!: ErrorDefinitionTranslation[];

    constructor(jsonData?: ErrorDefinition) {
        if (jsonData) {
            this.id = jsonData.id;
            this.errorId = jsonData.errorId;
            this.componentType = jsonData.componentType;
            this.errorLevel = jsonData.errorLevel;
            this.translations = [];
            jsonData.translations.forEach((type) => {
                this.translations.push(new ErrorDefinitionTranslation(type));
            });
        }
    }
}
